var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHidePasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.70718 21L22.7072 1.45479L21.293 0L17.3221 4.08485C15.6134 3.22128 13.8161 2.78479 11.9402 2.78479C7.61617 2.78479 3.79733 5.09346 0.487718 9.41936L0.000976562 10.0556L0.487718 10.6918C2.18803 12.9142 4.02322 14.6078 6.00293 15.7288L2.29297 19.5452L3.70718 21ZM7.4863 14.2028C5.79092 13.3559 4.1466 11.9879 2.5629 10.0555C5.47787 6.49788 8.6025 4.84218 11.9402 4.84218C12.0058 4.84218 12.0713 4.84281 12.1367 4.84409C10.9031 4.87858 9.67945 5.38011 8.7379 6.34867C6.90127 8.238 6.79217 11.2315 8.41062 13.252L7.4863 14.2028ZM9.83604 11.7857C8.99224 10.5797 9.0976 8.88824 10.1521 7.80346C11.2066 6.71868 12.8509 6.6103 14.0233 7.47832L9.83604 11.7857ZM15.4487 6.01199L15.8117 5.63856C14.9126 5.25466 13.9925 5.01057 13.0492 4.90409C13.9089 5.04224 14.7403 5.41154 15.4487 6.01199ZM21.7071 7.62696L13.7071 15.8565C13.3166 16.2583 12.6834 16.2583 12.2929 15.8565C11.9024 15.4548 11.9024 14.8035 12.2929 14.4017L20.2929 6.17217C20.6834 5.77044 21.3166 5.77044 21.7071 6.17217C22.0976 6.5739 22.0976 7.22523 21.7071 7.62696ZM23.7071 10.713C24.0976 10.3113 24.0976 9.65998 23.7071 9.25826C23.3166 8.85652 22.6834 8.85652 22.2929 9.25826L18.2929 13.373C17.9024 13.7748 17.9024 14.4261 18.2929 14.8278C18.6834 15.2296 19.3166 15.2296 19.7071 14.8278L23.7071 10.713Z",
    fill: "#212529"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 20,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidePasswordIcon);
export default __webpack_public_path__ + "static/media/HidePasswordIcon.0285b87c1413006277d551dc616278bc.svg";
export { ForwardRef as ReactComponent };